import { Route } from 'react-router-dom';
import { CreateAdjustmentPage } from './create-adjustment';
import { EditAdjustmentPage } from './edit-adjustment';
import { ListAdjustmentsPage } from './list-adjustments';
import { ViewAdjustmentPage } from './view-adjustment';
import { RequireAuth } from '/src/components';

export { CreateAdjustmentPage, EditAdjustmentPage, ListAdjustmentsPage, ViewAdjustmentPage };

export const adjustmentRoutes: React.ReactElement[] = [
  // Create
  <Route
    path="/adjustments/create"
    element={
      <RequireAuth>
        <CreateAdjustmentPage />
      </RequireAuth>
    }
  />,

  // Edit
  <Route
    path="/adjustments/:adjustmentId/edit"
    element={
      <RequireAuth>
        <EditAdjustmentPage />
      </RequireAuth>
    }
  />,

  // List
  <Route
    path="/adjustments"
    element={
      <RequireAuth>
        <ListAdjustmentsPage />
      </RequireAuth>
    }
  />,

  // View
  <Route
    path="/adjustments/:adjustmentId"
    element={
      <RequireAuth>
        <ViewAdjustmentPage />
      </RequireAuth>
    }
  />,
];
